import PropTypes from "prop-types";
import React, { Component } from "react";
import { withAlert } from "react-alert";
import {
  Grid,
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  Typography
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ptBrLocale from "date-fns/locale/pt-BR";
import Group from "../../waybee-ui/Group";
import Heading from "../../waybee-ui/Heading";
import BackButton from "../../components/BackButton";
import ClassService from "../../services/ClassService";
import ClassPlanService from "../../services/ClassPlanService";
import ClassPlanHeader from "./components/ClassPlanHeader";
import ClassPlanList from "./components/ClassPlanList";
import ClassPlanDialog from "./components/ClassPlanDialog";

class ClassPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subjects: [],
      loading: false,
      openDialog: false,
      selectedPlan: null,
      classPlan: null,
      filter: {
        date: null,
        subjects: ""
      }
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const subjects = await this.getCourses();
    let idTurmaDisc = "";

    if (typeof subjects === "string") {
      idTurmaDisc = subjects;
    } else if (subjects) {
      idTurmaDisc = subjects[0].idTurmaDisc;
    }

    const classPlan = await ClassPlanService.getClassPlan(null, idTurmaDisc);

    const updatedSubjects = subjects.map(course => ({
      ...course,
      NOME: course.name,
      CODDISC: course.name
    }));

    this.setState({
      filter: { subjects: idTurmaDisc },
      subjects: updatedSubjects,
      classPlan,
      loading: false
    });

    window.addEventListener("scroll", this.scrollEvent);
  }

  componentDidUpdate(prevProps, prevState) {
    this.updateClassPlan(prevState);
  }

  getCourses = async () => {
    const { match, alert } = this.props;
    const classId = match.params.id;

    try {
      const disciplines = await ClassService.getDisciplines(classId);
      if (disciplines && disciplines.length) {
        this.setFilter("course", disciplines[0]);
        return disciplines;
      }
    } catch (e) {
      console.error(e);
      alert.show("Ocorreu um erro ao buscar as disciplinas", { title: "Erro" });
    }

    return [];
  };

  setFilter(field, value) {
    const { filter } = this.state;
    this.setState({
      filter: {
        ...filter,
        [field]: value
      }
    });
  }

  onClickPlan = async classPlan => {
    this.setState({
      openDialog: true,
      selectedPlan: classPlan
    });
  };

  scrollEvent = () => {
    const { loading } = this.state;
    const container = document.querySelector("html");
    if (
      !loading &&
      container.scrollTop + window.innerHeight >= container.offsetHeight
    ) {
      this.reloadList();
    }
  };

  async updateClassPlan(prevState) {
    const { filter } = this.state;
    if (
      filter.subjects !== prevState.filter.subjects ||
      (filter.date !== prevState.filter.date &&
        !Number.isNaN(Number(filter.date)))
    ) {
      this.setState({ loading: true });
      const newClassPlan = await ClassPlanService.getClassPlan(
        filter.date,
        filter.subjects
      );

      this.setState({
        loading: false,
        classPlan: newClassPlan
      });
    }
  }

  async reloadList() {
    const { filter, loading } = this.state;
    if (filter && !loading) {
      this.setState({ loading: true });
      const reloadedList = await ClassPlanService.getClassPlan(
        filter.date,
        filter.subjects
      );

      this.setState({
        loading: false,
        classPlan: reloadedList
      });
    }
  }

  render() {
    const {
      filter,
      subjects,
      classPlan,
      loading,
      openDialog,
      selectedPlan
    } = this.state;
    const { history } = this.props;

    return (
      <Grid container spacing={2}>
        <BackButton onClick={history.goBack} />
        <Grid item xs={12}>
          <Group>
            <Box>
              <Heading level={1} icon="class" gutterBottom>
                Plano de Aula
              </Heading>
              <Box mt={1} mb={2}>
                <form noValidate autoComplete="off">
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={ptBrLocale}
                  >
                    <Grid container spacing={8}>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <InputLabel id="filter-subjects-label">
                            Disciplina
                          </InputLabel>
                          <Select
                            fullWidth
                            labelId="filter-subjects-label"
                            value={filter.subjects}
                            onChange={e =>
                              this.setFilter("subjects", e.target.value)}
                          >
                            {subjects.map(subject => (
                              <MenuItem
                                key={subject.idTurmaDisc}
                                value={subject.idTurmaDisc}
                              >
                                {subject.NOME}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <KeyboardDatePicker
                          disableToolbar
                          variant="inline"
                          format="dd/MM/yyyy"
                          id="date-picker-inline"
                          label="Data"
                          value={filter.date}
                          onChange={date => {
                            this.setFilter("date", date);
                          }}
                          fullWidth
                          invalidDateMessage="Data inválida"
                        />
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </form>
              </Box>
              <Box>
                <Table>
                  <TableBody>
                    <ClassPlanHeader />
                    {classPlan && !loading && (
                      <ClassPlanList
                        data={classPlan}
                        onClick={this.onClickPlan}
                      />
                    )}
                  </TableBody>
                </Table>

                {loading && (
                  <Box p={6} textAlign="center">
                    <CircularProgress />
                  </Box>
                )}

                {!loading && (!classPlan || !classPlan.length) && (
                  <Box p={6} textAlign="center">
                    <Typography>Nenhum Plano de Aula encontrado</Typography>
                  </Box>
                )}

                {selectedPlan && (
                  <ClassPlanDialog
                    open={openDialog}
                    selectedPlan={selectedPlan}
                    onClose={() => {
                      this.setState({ openDialog: false, selectedPlan: null });
                      this.reloadList();
                    }}
                  />
                )}
              </Box>
            </Box>
          </Group>
        </Grid>
      </Grid>
    );
  }
}

ClassPlan.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.any
  }),
  alert: PropTypes.shape({
    show: PropTypes.func
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.any
  }).isRequired
};

ClassPlan.defaultProps = {
  match: {
    params: {}
  }
};

export default withAlert()(withRouter(ClassPlan));
